import type { Template } from "@/types";

export const LA_05_H5_V0: Template[] = [
    {
        id: "la-05-h5v0-01",
        name: "LA 01 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h5_v0_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 98, y: 87, width: 237, height: 152, rotation: 0, imageRotation: 0 },
            { id: "2", x: 98, y: 246, width: 237, height: 152, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 87, width: 237, height: 152, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 246, width: 237, height: 152, rotation: 0, imageRotation: 0 },
            { id: "5", x: 774, y: 87, width: 480, height: 311, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-02",
        name: "LA 02 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h5_v0_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 94, y: 38, width: 487, height: 289, rotation: 0, imageRotation: 0 },
            { id: "2", x: 94, y: 334, width: 158, height: 111, rotation: 0, imageRotation: 0 },
            { id: "3", x: 260, y: 334, width: 157, height: 111, rotation: 0, imageRotation: 0 },
            { id: "4", x: 425, y: 334, width: 157, height: 111, rotation: 0, imageRotation: 0 },
            { id: "5", x: 735, y: 66, width: 557, height: 353, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-03",
        name: "LA 03 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h5_v0_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 235, y: 48, width: 207, height: 125, rotation: 0, imageRotation: 0 },
            { id: "2", x: 235, y: 180, width: 207, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 235, y: 312, width: 207, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 854, y: 48, width: 321, height: 190, rotation: 0, imageRotation: 0 },
            { id: "5", x: 854, y: 245, width: 321, height: 190, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-04",
        name: "LA 04 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h5_v0_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 237, y: 40, width: 204, height: 129, rotation: 0, imageRotation: 0 },
            { id: "2", x: 131, y: 177, width: 204, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 177, width: 204, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 237, y: 313, width: 204, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 749, y: 73, width: 532, height: 338, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-05",
        name: "LA 05 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h5_v0_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 152, width: 264, height: 180, rotation: 0, imageRotation: 0 },
            { id: "2", x: 272, y: 152, width: 264, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 544, y: 152, width: 264, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 152, width: 264, height: 180, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1088, y: 152, width: 264, height: 180, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-06",
        name: "LA 06 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h5_v0_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 40, y: 157, width: 248, height: 169, rotation: 0, imageRotation: 0 },
            { id: "2", x: 296, y: 157, width: 248, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 552, y: 157, width: 248, height: 169, rotation: 0, imageRotation: 0 },
            { id: "4", x: 808, y: 157, width: 248, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1064, y: 157, width: 248, height: 169, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-07",
        name: "LA 07 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h5_v0_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 436, y: 33, width: 647, height: 417, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 351, width: 158, height: 99, rotation: 0, imageRotation: 0 },
            { id: "3", x: 270, y: 245, width: 158, height: 99, rotation: 0, imageRotation: 0 },
            { id: "4", x: 270, y: 139, width: 158, height: 99, rotation: 0, imageRotation: 0 },
            { id: "5", x: 270, y: 33, width: 158, height: 99, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-08",
        name: "LA 08 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h5_v0_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 41, y: 50, width: 593, height: 382, rotation: 0, imageRotation: 0 },
            { id: "2", x: 717, y: 50, width: 292, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 717, y: 245, width: 292, height: 187, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1017, y: 50, width: 293, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1017, y: 245, width: 293, height: 187, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-09",
        name: "LA 09 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h5_v0_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 49, y: 41, width: 308, height: 197, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 245, width: 308, height: 197, rotation: 0, imageRotation: 0 },
            { id: "3", x: 365, y: 41, width: 622, height: 401, rotation: 0, imageRotation: 0 },
            { id: "4", x: 995, y: 41, width: 307, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 995, y: 245, width: 307, height: 197, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-10",
        name: "LA 10 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h5_v0_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 50, y: 41, width: 308, height: 197, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 245, width: 308, height: 197, rotation: 0, imageRotation: 0 },
            { id: "3", x: 366, y: 41, width: 307, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 366, y: 245, width: 307, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 41, width: 622, height: 401, rotation: 0, imageRotation: 0 }
        ],
    }
];